(() => {
  if (window.__figmaProductInfoReady) return;
  window.__figmaProductInfoReady = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-figma-size-guide-open]');

    if (opener) {
      const dialogId = opener.getAttribute('data-figma-size-guide-open');
      const dialog = document.getElementById(dialogId);

      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }

      return;
    }

    const closer = event.target.closest('[data-figma-size-guide-close]');

    if (closer) {
      const dialog = closer.closest('dialog');

      if (dialog) {
        event.preventDefault();
        dialog.close();
      }
    }
  });

  document.addEventListener('click', (event) => {
    if (typeof HTMLDialogElement !== 'undefined' && event.target instanceof HTMLDialogElement && event.target.classList.contains('figma-size-guide-dialog')) {
      const rect = event.target.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;

      if (!inside) event.target.close();
    }
  });
})();
